/**
 * Mock Theme Data for Demo/Testing
 * This simulates the theme_settings from the API
 */

export const commonFonts = {
  PoppinsL: 'Poppins-Light',
  PoppinsR: 'Poppins-Regular',
  PoppinsM: 'Poppins-Medium',
  PoppinsB: 'Poppins-Bold',
  PoppinsSB: 'Poppins-SemiBold',
  OleoScriptB: 'OleoScript-Bold',
  OleoScriptR: 'OleoScript-Regular',
};


// Default Theme: Royal Purple - Premium & Modern Hotel Booking
export const mockThemeSettings = {
    colors: {

        primary: '#000000ff',        
        primaryHover: '#343578',  
        primaryLight: '#EDE9FE',  
        secondary: '#F97316',
        secondaryHover: '#EA580C',
        secondaryLight: '#e9c905',
        background: '#FFFFFF',
        backgroundAlt: '#FAFAF9',
        backgroundDark: '#1C1917',
        text: '#1C1917',
        textMuted: '#57534E',
        textLight: '#A8A29E',
        textInverse: '#FFFFFF',
        success: '#15803D',       
        successLight: '#DCFCE7',
        error: '#DC2626',         
        errorLight: '#FEE2E2',
        warning: '#B45309',       
        warningLight: '#FEF9C3',
        info: '#0284C7',         
        infoLight: '#E0F2FE',
        border: '#E7E5E4',
        borderDark: '#D6D3D1',
        divider: '#F5F5F4',
        cardBackground: '#FFFFFF',
        cardBorder: '#E7E5E4',
        headerBackground: '#FFFFFF',
        headerText: '#1C1917',
        footerBackground: '#1C1917',
        footerText: '#FFFFFF',
        buttonPrimaryBg: '#363636',       
        buttonPrimaryText: '#e9c905',
        buttonPrimaryHover: '#484848ff',
        buttonSecondaryBg: '#f0484e',      
        buttonSecondaryText: '#FFFFFF',
        buttonSecondaryHover: '#EA580C',
        buttonOutlineBg: 'transparent',    
        buttonOutlineText: '#363636',
        buttonOutlineBorder: '#363636',
        buttonOutlineHover: '#EDE9FE',
        buttonDisabledBg: '#E7E5E4',
        buttonDisabledText: '#A8A29E',
        linkColor: '#363636',  
        linkHover: '#363636',
        inputBackground: '#FFFFFF',
        inputBorder: '#D6D3D1',
        inputFocus: '#363636',
        inputPlaceholder: '#A8A29E',
        skeletonBase: '#F5F5F4',
        skeletonHighlight: '#E7E5E4',



        // primary: '#000000ff',        
        // primaryHover: '#9A3412',  
        // primaryLight: '#FFEDD5',  
        // secondary: '#B91C1C',
        // secondaryHover: '#991B1B',
        // secondaryLight: '#FEE2E2',
        // background: '#f4eed9',
        // backgroundAlt: '#FEF3C7',
        // backgroundDark: '#7C2D12',
        // text: '#292524',
        // textMuted: '#44403C',
        // textLight: '#A8A29E',
        // textInverse: '#FFFFFF',
        // success: '#15803D',       
        // successLight: '#DCFCE7',
        // error: '#B91C1C',         
        // errorLight: '#FEE2E2',
        // warning: '#FEF3C7',     
        // warningLight: '#FEF3C7',
        // info: '#0284C7',          
        // infoLight: '#E0F2FE',
        // border: '#FED7AA',
        // borderDark: '#FDBA74',
        // divider: '#FEF3C7',
        // cardBackground: '#FFFFFF',
        // cardBorder: '#FED7AA',
        // headerBackground: '#f4eed9',
        // headerText: '#292524',
        // footerBackground: '#7C2D12',
        // footerText: '#FFFFFF',
        // buttonPrimaryBg: '#ff7424',       
        // buttonPrimaryText: '#FFFFFF',
        // buttonPrimaryHover: '#f98441ff',
        // buttonSecondaryBg: '#B91C1C',      
        // buttonSecondaryText: '#FFFFFF',
        // buttonSecondaryHover: '#991B1B',
        // buttonOutlineBg: 'transparent',    
        // buttonOutlineText: '#C2410C',
        // buttonOutlineBorder: '#C2410C',
        // buttonOutlineHover: '#FFEDD5',
        // buttonDisabledBg: '#E7E5E4',
        // buttonDisabledText: '#A8A29E',
        // linkColor: '#C2410C',
        // linkHover: '#9A3412',
        // inputBackground: '#FFFFFF',
        // inputBorder: '#FED7AA',
        // inputFocus: '#C2410C',
        // inputPlaceholder: '#A8A29E',
        // skeletonBase: '#FEF3C7',
        // skeletonHighlight: '#FED7AA'
    },
    spacing: {
        borderRadius: 10,       // slightly softer feels more "hospitality"
        borderRadiusSm: 6,
        borderRadiusLg: 14,
        cardPadding: 20,
        sectionGap: 32
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Neutral, premium shadows (avoid tinted shadows on photo-heavy pages)
        boxShadow: '0px 4px 18px rgba(28, 25, 23, 0.10)',
        boxShadowCard: '0px 10px 30px rgba(28, 25, 23, 0.12)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Theme 1: Ocean Blue - Clean & Professional
export const oceanHotelBookingTheme = {
    colors: {
        /**
         * Hotels: bias toward calm + premium, with a clear “Book now” CTA.
         * - Primary: deeper ocean blue (trust + conversion)
         * - Secondary: refined teal (filters, secondary actions)
         * - Info/links: brighter sky (discoverability)
         */

        // Primary actions (Book / Pay / Reserve)
        primary: '#075985',        // Ocean Blue (strong CTA, premium)
        primaryHover: '#0C4A6E',   // Deeper hover
        primaryLight: '#E0F2FE',   // Sky wash for highlights/badges

        // Secondary actions (Modify dates / Apply filters / Add-ons)
        secondary: '#0F766E',
        secondaryHover: '#115E59',
        secondaryLight: '#CCFBF1',

        // Surfaces (hotel UIs are content-heavy: cards, tiles, photos)
        background: '#FFFFFF',
        backgroundAlt: '#F8FAFC',
        backgroundDark: '#0B1220',

        // Text (slightly warmer muted text reads better with imagery)
        text: '#0F172A',
        textMuted: '#475569',
        textLight: '#94A3B8',
        textInverse: '#FFFFFF',

        // Status (hotel-specific semantics)
        success: '#15803D',        // Booking confirmed / available
        successLight: '#DCFCE7',
        error: '#B91C1C',          // Payment failed / sold out
        errorLight: '#FEE2E2',
        warning: '#B45309',        // Limited rooms / policy warnings
        warningLight: '#FEF3C7',
        info: '#0EA5E9',           // Helpful info / “Free cancellation” tag
        infoLight: '#E0F2FE',

        // Borders & dividers (keep subtle; imagery already adds contrast)
        border: '#E2E8F0',
        borderDark: '#CBD5E1',
        divider: '#F1F5F9',

        // Cards / layout regions
        cardBackground: '#FFFFFF',
        cardBorder: '#E2E8F0',
        headerBackground: '#FFFFFF',
        headerText: '#0F172A',
        footerBackground: '#0B1220',
        footerText: '#FFFFFF',

        // Buttons - Standard UI Practices
        buttonPrimaryBg: '#075985',        // Primary action (Book Now, Submit)
        buttonPrimaryText: '#FFFFFF',
        buttonPrimaryHover: '#0C4A6E',
        buttonSecondaryBg: '#0F766E',      // Secondary action (teal)
        buttonSecondaryText: '#FFFFFF',
        buttonSecondaryHover: '#115E59',
        buttonOutlineBg: 'transparent',    // Tertiary/Ghost
        buttonOutlineText: '#075985',
        buttonOutlineBorder: '#075985',
        buttonOutlineHover: '#E0F2FE',
        buttonDisabledBg: '#E2E8F0',
        buttonDisabledText: '#94A3B8',

        // Links - Primary color for consistency
        linkColor: '#075985',
        linkHover: '#0C4A6E',

        // Inputs (date picker, guest selector, promo code)
        inputBackground: '#FFFFFF',
        inputBorder: '#CBD5E1',
        inputFocus: '#075985',
        inputPlaceholder: '#94A3B8',

        // Skeleton loaders
        skeletonBase: '#F1F5F9',
        skeletonHighlight: '#E2E8F0'
    },
    spacing: {
        borderRadius: 10,       // slightly softer feels more “hospitality”
        borderRadiusSm: 6,
        borderRadiusLg: 14,
        cardPadding: 20,
        sectionGap: 32
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Neutral, premium shadows (avoid tinted shadows on photo-heavy pages)
        boxShadow: '0px 4px 18px rgba(15, 23, 42, 0.10)',
        boxShadowCard: '0px 10px 30px rgba(15, 23, 42, 0.12)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Theme 2: Rose Garden - Elegant Boutique Hotel Booking
export const roseGardenTheme = {
    colors: {
        /**
         * Hotels: Rose tones evoke romance, boutique luxury, and elegance
         * - Primary: Deep rose (bold CTA, romantic/boutique feel)
         * - Secondary: Soft violet (spa, amenities, secondary actions)
         * - Info/links: Lighter rose for discoverability
         */

        // Primary actions (Book / Pay / Reserve)
        primary: '#BE123C',        // Deep Rose (romantic, boutique luxury)
        primaryHover: '#9F1239',   // Deeper hover
        primaryLight: '#FFE4E6',   // Blush wash for highlights/badges

        // Secondary actions (Modify dates / Apply filters / Add-ons)
        secondary: '#7C3AED',
        secondaryHover: '#6D28D9',
        secondaryLight: '#F3E8FF',

        // Surfaces (hotel UIs are content-heavy: cards, tiles, photos)
        background: '#FFFFFF',
        backgroundAlt: '#FFF1F2',
        backgroundDark: '#881337',

        // Text (warm gray tones complement rose)
        text: '#1F2937',
        textMuted: '#4B5563',
        textLight: '#9CA3AF',
        textInverse: '#FFFFFF',

        // Status (hotel-specific semantics)
        success: '#15803D',        // Booking confirmed / available
        successLight: '#DCFCE7',
        error: '#B91C1C',          // Payment failed / sold out
        errorLight: '#FEE2E2',
        warning: '#B45309',        // Limited rooms / policy warnings
        warningLight: '#FEF3C7',
        info: '#0284C7',           // Informational - distinct blue
        infoLight: '#E0F2FE',

        // Borders & dividers (keep subtle; imagery already adds contrast)
        border: '#FECDD3',
        borderDark: '#FDA4AF',
        divider: '#FFF1F2',

        // Cards / layout regions
        cardBackground: '#FFFFFF',
        cardBorder: '#FECDD3',
        headerBackground: '#FFFFFF',
        headerText: '#1F2937',
        footerBackground: '#881337',
        footerText: '#FFFFFF',

        // Buttons - Standard UI Practices
        buttonPrimaryBg: '#BE123C',        // Primary action (Book Now, Submit)
        buttonPrimaryText: '#FFFFFF',
        buttonPrimaryHover: '#9F1239',
        buttonSecondaryBg: '#7C3AED',      // Secondary action (violet)
        buttonSecondaryText: '#FFFFFF',
        buttonSecondaryHover: '#6D28D9',
        buttonOutlineBg: 'transparent',    // Tertiary/Ghost
        buttonOutlineText: '#BE123C',
        buttonOutlineBorder: '#BE123C',
        buttonOutlineHover: '#FFE4E6',
        buttonDisabledBg: '#FECDD3',
        buttonDisabledText: '#9CA3AF',

        // Links - Primary color for consistency
        linkColor: '#BE123C',
        linkHover: '#9F1239',

        // Inputs (date picker, guest selector, promo code)
        inputBackground: '#FFFFFF',
        inputBorder: '#FECDD3',
        inputFocus: '#BE123C',
        inputPlaceholder: '#9CA3AF',

        // Skeleton loaders
        skeletonBase: '#FFF1F2',
        skeletonHighlight: '#FECDD3'
    },
    spacing: {
        borderRadius: 12,       // softer corners for boutique feel
        borderRadiusSm: 6,
        borderRadiusLg: 16,
        cardPadding: 24,
        sectionGap: 36
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Subtle rose-tinted shadows for warmth
        boxShadow: '0px 4px 18px rgba(136, 19, 55, 0.08)',
        boxShadowCard: '0px 10px 30px rgba(136, 19, 55, 0.10)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Theme 3: Forest Green - Eco-Resort & Nature Hotel Booking
export const forestGreenTheme = {
    colors: {
        primary: '#047857',        
        primaryHover: '#065F46',  
        primaryLight: '#D1FAE5',   
        secondary: '#65A30D',
        secondaryHover: '#4D7C0F',
        secondaryLight: '#ECFCCB',
        background: '#FFFFFF',
        backgroundAlt: '#F0FDF4',
        backgroundDark: '#14532D',
        text: '#14532D',
        textMuted: '#3F6212',
        textLight: '#84CC16',
        textInverse: '#FFFFFF',
        success: '#15803D',       
        successLight: '#DCFCE7',
        error: '#B91C1C',          
        errorLight: '#FEE2E2',
        warning: '#A16207',        
        warningLight: '#FEF9C3',
        info: '#059669',          
        infoLight: '#D1FAE5',
        border: '#BBF7D0',
        borderDark: '#86EFAC',
        divider: '#F0FDF4',
        cardBackground: '#FFFFFF',
        cardBorder: '#BBF7D0',
        headerBackground: '#FFFFFF',
        headerText: '#14532D',
        footerBackground: '#14532D',
        footerText: '#FFFFFF',
        buttonPrimaryBg: '#047857',      
        buttonPrimaryText: '#FFFFFF',
        buttonPrimaryHover: '#065F46',
        buttonSecondaryBg: '#65A30D',      
        buttonSecondaryText: '#FFFFFF',
        buttonSecondaryHover: '#4D7C0F',
        buttonOutlineBg: 'transparent',    
        buttonOutlineText: '#047857',
        buttonOutlineBorder: '#047857',
        buttonOutlineHover: '#D1FAE5',
        buttonDisabledBg: '#BBF7D0',
        buttonDisabledText: '#84CC16',
        linkColor: '#047857',
        linkHover: '#065F46',
        inputBackground: '#FFFFFF',
        inputBorder: '#BBF7D0',
        inputFocus: '#047857',
        inputPlaceholder: '#84CC16',
        skeletonBase: '#F0FDF4',
        skeletonHighlight: '#DCFCE7'
    },
    spacing: {
        borderRadius: 10,      
        borderRadiusSm: 6,
        borderRadiusLg: 14,
        cardPadding: 20,
        sectionGap: 32
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Subtle green-tinted shadows for nature feel
        boxShadow: '0px 4px 18px rgba(20, 83, 45, 0.08)',
        boxShadowCard: '0px 10px 30px rgba(20, 83, 45, 0.10)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Theme 4: Midnight Dark - Premium Dark Mode Hotel Booking
export const midnightDarkTheme = {
    colors: {
        primary: '#818CF8',      
        primaryHover: '#A5B4FC',  
        primaryLight: '#312E81',  
        secondary: '#F472B6',
        secondaryHover: '#F9A8D4',
        secondaryLight: '#831843',
        background: '#0F0F23',
        backgroundAlt: '#1A1A2E',
        backgroundDark: '#000000',
        text: '#F3F4F6',
        textMuted: '#9CA3AF',
        textLight: '#6B7280',
        textInverse: '#0F0F23',
        success: '#34D399',        
        successLight: '#064E3B',
        error: '#F87171',         
        errorLight: '#7F1D1D',
        warning: '#FBBF24',        
        warningLight: '#78350F',
        info: '#60A5FA',          
        infoLight: '#1E3A8A',
        border: '#374151',
        borderDark: '#4B5563',
        divider: '#1F2937',
        cardBackground: '#1A1A2E',
        cardBorder: '#374151',
        headerBackground: '#0F0F23',
        headerText: '#F3F4F6',
        footerBackground: '#000000',
        footerText: '#F3F4F6',
        buttonPrimaryBg: '#818CF8',      
        buttonPrimaryText: '#0F0F23',
        buttonPrimaryHover: '#A5B4FC',
        buttonSecondaryBg: '#F472B6',      
        buttonSecondaryText: '#0F0F23',
        buttonSecondaryHover: '#F9A8D4',
        buttonOutlineBg: 'transparent',    
        buttonOutlineText: '#818CF8',
        buttonOutlineBorder: '#818CF8',
        buttonOutlineHover: '#312E81',
        buttonDisabledBg: '#374151',
        buttonDisabledText: '#6B7280',
        linkColor: '#A5B4FC',
        linkHover: '#C7D2FE',
        inputBackground: '#1A1A2E',
        inputBorder: '#374151',
        inputFocus: '#818CF8',
        inputPlaceholder: '#6B7280',
        skeletonBase: '#1F2937',
        skeletonHighlight: '#374151'
    },
    spacing: {
        borderRadius: 10,       // consistent with other themes
        borderRadiusSm: 6,
        borderRadiusLg: 14,
        cardPadding: 20,
        sectionGap: 32
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Subtle glow shadows for dark mode
        boxShadow: '0px 4px 18px rgba(129, 140, 248, 0.15)',
        boxShadowCard: '0px 10px 30px rgba(0, 0, 0, 0.40)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Theme 5: Sunset Orange - Warm Resort & Beach Hotel Booking
export const sunsetOrangeTheme = {
    colors: {
        primary: '#C2410C',        
        primaryHover: '#9A3412',  
        primaryLight: '#FFEDD5',  
        secondary: '#B91C1C',
        secondaryHover: '#991B1B',
        secondaryLight: '#FEE2E2',
        background: '#f4eed9',
        backgroundAlt: '#FEF3C7',
        backgroundDark: '#7C2D12',
        text: '#292524',
        textMuted: '#44403C',
        textLight: '#A8A29E',
        textInverse: '#FFFFFF',
        success: '#15803D',       
        successLight: '#DCFCE7',
        error: '#B91C1C',         
        errorLight: '#FEE2E2',
        warning: '#FEF3C7',     
        warningLight: '#FEF3C7',
        info: '#0284C7',          
        infoLight: '#E0F2FE',
        border: '#FED7AA',
        borderDark: '#FDBA74',
        divider: '#FEF3C7',
        cardBackground: '#FFFFFF',
        cardBorder: '#FED7AA',
        headerBackground: '#f4eed9',
        headerText: '#292524',
        footerBackground: '#7C2D12',
        footerText: '#FFFFFF',
        buttonPrimaryBg: '#ff7424',       
        buttonPrimaryText: '#FFFFFF',
        buttonPrimaryHover: '#f98441ff',
        buttonSecondaryBg: '#B91C1C',      
        buttonSecondaryText: '#FFFFFF',
        buttonSecondaryHover: '#991B1B',
        buttonOutlineBg: 'transparent',    
        buttonOutlineText: '#C2410C',
        buttonOutlineBorder: '#C2410C',
        buttonOutlineHover: '#FFEDD5',
        buttonDisabledBg: '#E7E5E4',
        buttonDisabledText: '#A8A29E',
        linkColor: '#C2410C',
        linkHover: '#9A3412',
        inputBackground: '#FFFFFF',
        inputBorder: '#FED7AA',
        inputFocus: '#C2410C',
        inputPlaceholder: '#A8A29E',
        skeletonBase: '#FEF3C7',
        skeletonHighlight: '#FED7AA'
    },
    spacing: {
        borderRadius: 10,       
        borderRadiusSm: 6,
        borderRadiusLg: 14,
        cardPadding: 20,
        sectionGap: 32
    },

    layout: {
        headerFixed: true,
        headerHeight: 85,
        maxContentWidth: 1200
    },

    effects: {
        // Warm orange-tinted shadows for tropical feel
        boxShadow: '0px 4px 18px rgba(124, 45, 18, 0.08)',
        boxShadowCard: '0px 10px 30px rgba(124, 45, 18, 0.10)',
        transition:
            'color 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease'
    }
};

// Collection of all themes for easy access
export const allThemes = {
    default: mockThemeSettings,
    oceanBlue: oceanHotelBookingTheme,
    roseGarden: roseGardenTheme,
    forestGreen: forestGreenTheme,
    midnightDark: midnightDarkTheme,
    sunsetOrange: sunsetOrangeTheme
};

// Helper function to get theme by name
export const getThemeByName = (themeName) => {
    return allThemes[themeName] || mockThemeSettings;
};

export default mockThemeSettings;
